export default "__VITE_ASSET__B412F_jI__"